<template>
  <div>
    <div class="bg-gray-100 w-full intro">
      <h1>Welcome to Witness</h1>
      <p>Select your Distrikt</p>
    </div>
    <div class="table">
      <div
        class="card"
        @click="select(item)"
        v-for="(item, index) in $store.distrikts"
        :key="index"
        :style="'background: url(' + item.image + ')'"
      >
        <div class="card_text">
          <h2>{{ item.name }}</h2>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data: () => ({ distrikt: null, distrikts: null }),
  methods: {
    select(item) {
      this.$store.user.distrikt = item;
      this.nextStep();
    },
  },
  async created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.intro {
  height: 200px;
  @apply flex items-center justify-center flex-col;
  h1 {
    font-family: "EB Garamond", serif;
    @apply text-5xl;
  }
  p {
    @apply mt-4 font-bold text-xl;
  }
}
.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100%;
}
.table {
  width: 90%;
  max-width: 1100px;
  display: flex;
  margin: 0 auto;
}
.card {
  border: 10px solid white;
  @apply shadow-lg;
  flex: 1;
  background-color: black;
  width: 30%;
  height: 420px;
  background-size: cover !important;
  margin: 10px 20px 0;
  position: relative;
  display: block;
  overflow: hidden;
  .card_text {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 200%
    );
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;

    @apply pb-4;
    h2 {
      @apply font-bold text-2xl border-b pb-2 mb-3;
      width: 80%;
    }
    p {
      @apply mx-6;
    }
  }
  img {
    height: 300px;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
